import { compose } from 'redux';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import { ServiceTimeClass } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';

import { commanderForm, presence, timeRangeBasedOnTimeUnit, timeString, validation } from '@mews-commander/legacy-form';
import { isAccountingCategorySetupRequired } from '@mews-commander/legacy-entities/src/ducks/accountingConfigurations';
import { addBookableService, handleBookablePeriodChange } from '../actions/actions';
import { getDefaulLocalizedTimes } from '../selectors';
import { fieldNames } from '../constants';
import { BookableServiceCreateFormProps, BookableServiceCreateFormValues } from '../types';
import BookableServiceCreateFormFields from './BookableServiceCreateFormFields';

interface ConstraintsProps {
    accountingCategorySetupRequired: boolean;
}

const getConstraints = ({ accountingCategorySetupRequired }: ConstraintsProps) => ({
    [fieldNames.NAME]: { presence },
    [fieldNames.BOOKABLE_PERIOD]: { presence },
    [fieldNames.ARRIVAL_TIME]: {
        presence,
        timeString,
        timeRangeBasedOnTimeUnit,
    },
    [fieldNames.DEPARTURE_TIME]: {
        presence,
        timeString,
        timeRangeBasedOnTimeUnit,
    },
    [fieldNames.ACCOUNTING_CATEGORY_ID]: accountingCategorySetupRequired ? { presence } : {},
    [fieldNames.REBATE_ACCOUNTING_CATEGORY_ID]: accountingCategorySetupRequired ? { presence } : {},
});

interface DispatchProps {
    onSubmit: (values: BookableServiceCreateFormValues) => void;
    onBookablePeriodChange: (bookablePeriod: ServiceTimeClass) => void;
}

interface BookableServiceFormValues {
    [fieldNames.ARRIVAL_TIME]: string;
    [fieldNames.DEPARTURE_TIME]: string;
}
interface StateProps {
    initialValues: BookableServiceFormValues;
    accountingCategorySetupRequired: boolean;
    timePickersVisible: boolean;
}

export default compose(
    connect<StateProps, DispatchProps, BookableServiceCreateFormProps, ApplicationState>(
        (state, { form, enterpriseId }) => {
            const formSelector = formValueSelector<ApplicationState>(form);
            const bookablePeriod = formSelector(state, fieldNames.BOOKABLE_PERIOD);

            const { arrivalTime, departureTime } = getDefaulLocalizedTimes(bookablePeriod)(state);

            return {
                initialValues: {
                    [fieldNames.ARRIVAL_TIME]: arrivalTime,
                    [fieldNames.DEPARTURE_TIME]: departureTime,
                },
                // @ts-expect-error $TSFixMeError: Expected 1 arguments, but got 2.
                accountingCategorySetupRequired: isAccountingCategorySetupRequired(state, { enterpriseId }),
                timePickersVisible: bookablePeriod !== ServiceTimeClass.Hour,
            };
        },
        (dispatch: CommanderThunkDispatch, { enterpriseId, form }) => ({
            onSubmit: (values) => dispatch(addBookableService(enterpriseId, values)),
            onBookablePeriodChange: (bookablePeriod) => dispatch(handleBookablePeriodChange(bookablePeriod, form)),
        })
    ),
    commanderForm({
        submitLabel: <LocalizedText textKey={TextKey.CreateNewService} />,
        validate: validation(getConstraints),
        submitButtonProps: { variant: 'primary' },
    })
)(BookableServiceCreateFormFields);
